module.exports = __webpack_public_path__ + "img/IMO.9edf0383.png";